import { rokidRcsUrl } from "@rokid/host";
import {ISystemParam} from './home.d';

import {
  request,
  type IRequest,
  type IResult,
  type pageData,
} from "@rokid/utils";


//获取系统参数中配置的公告
export const getNews: IRequest<undefined, ISystemParam> = () => {
  return request({
    url: `${rokidRcsUrl}/systemParam/getParam`,
    method: "post",
     data: {"code":"agent_frontend_news"}
  }).then((res) => res.data);
};


